import { createSlice } from "@reduxjs/toolkit";

interface registrationState {
  featureFalgs: { [key: string]: boolean };
}

const initialState: registrationState = {
featureFalgs: {}
};

const registrationDataSlice = createSlice({
  name: "registrationState",
  initialState,
  reducers: {
    setfeatureFlags: (state, data) => {
      state.featureFalgs = data.payload;
    },
},
});

export const {
    setfeatureFlags
} = registrationDataSlice.actions;

export default registrationDataSlice.reducer;
